import { defineStore } from 'pinia';
import api from '@/services/api';
import concepto_model from '@/shared/models/concepto_model';
import { getParamsUrl } from './concepto_utils';

export const useConceptoStore = defineStore('conceptoStore', {
  state: () => ({
    entity: 'concepto',
    conceptos: [],
    concepto: { ...concepto_model },
    page: 1,
    filters: {},
  }),
  getters: {},
  actions: {
    async findAllConceptoHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, Activo: true, ...this.filters, ...params })}`,
      );
      if (result && result.data.length > 0) {
        this.conceptos.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    async saveConcepto() {
      if (this.concepto.Codigo) {
        return await this.updateConceptoHTTP();
      } else {
        return await this.createConceptoHTTP();
      }
    },
    async createConceptoHTTP() {
      return await api.post(`/${this.entity}`, this.concepto);
    },
    async updateConceptoHTTP() {
      return await api.patch(`/${this.entity}/${this.concepto.Codigo}`, this.concepto);
    },
    async deleteConceptoHTTP(concepto) {
      return await api.patch(`/${this.entity}/${concepto.Codigo}`, { ...concepto, Activo: false });
    },
    cleanConcepto() {
      this.concepto = { ...concepto_model };
    },
    setPage(page) {
      this.page = page;
    },
    async firstRequest() {
      this.setPage(1);
      this.emptyList();
      await this.findAllConceptoHTTP();
    },
    emptyList() {
      this.conceptos = [];
    },
  },
});
